import type { PlannerData, SearchResult } from '../types';

const normalize = (value: string) => value.toLocaleLowerCase('en').normalize('NFKC');

export const searchPlannerData = (data: PlannerData, query: string): SearchResult[] => {
  const needle = normalize(query.trim());
  if (!needle) return [];
  const candidates: SearchResult[] = [
    ...data.tasks.map((record) => ({ id: record.id, kind: 'task' as const, title: record.title, excerpt: record.description, updatedAt: record.updatedAt })),
    ...data.events.map((record) => ({ id: record.id, kind: 'event' as const, title: record.title, excerpt: `${record.description} ${record.location}`.trim(), updatedAt: record.updatedAt })),
    ...data.notes.map((record) => ({ id: record.id, kind: 'note' as const, title: record.title || 'Untitled note', excerpt: record.content, updatedAt: record.updatedAt })),
    ...data.shoppingItems.map((record) => ({ id: record.id, kind: 'shopping' as const, title: record.name, excerpt: `${record.notes} ${record.store}`.trim(), updatedAt: record.updatedAt }))
  ];
  return candidates
    .filter((record) => normalize(`${record.title} ${record.excerpt}`).includes(needle))
    .sort((first, second) => second.updatedAt.localeCompare(first.updatedAt));
};
